import { Head } from '@inertiajs/react';
import { Schedule } from '@/components/schedule';
import { cn } from '@/lib/utils';
import type { SchedulesShow } from '@/types';
import { Ph26Shell } from './components/Ph26Shell';

// /schedule, /26-co/schedule and /26-mx/schedule as one component (PORTING.md G5). What
// differs is the face, the two headline rows the 26 pages print and the wordmark the
// un-slugged page puts in the corner.
export default function Show({
  event,
  timeSlots,
  titleFont,
  editionLabel,
  dateLine,
  description,
  theme26,
  platanusLogo,
  timezoneOffset,
  timeZone,
}: SchedulesShow) {
  return (
    <Ph26Shell enabled={theme26}>
      <Head title={`${event.name} - Cronograma`}>
        {description && (
          <meta head-key="description" name="description" content={description} />
        )}
      </Head>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8 md:py-12">
          {platanusLogo && (
            <div className="absolute top-4 right-4 z-20 hidden md:top-8 md:right-8 md:block">
              <div
                className="aspect-[576/112] h-10 w-auto"
                style={{
                  backgroundColor: 'hsl(var(--primary))',
                  maskImage: 'url(/assets/logos/platanus.svg)',
                  maskSize: 'contain',
                  maskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  WebkitMaskImage: 'url(/assets/logos/platanus.svg)',
                  WebkitMaskSize: 'contain',
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                }}
              />
            </div>
          )}

          <div className="mx-auto max-w-7xl space-y-6">
            <div className="text-center">
              <h1
                className={cn(
                  'inline-block font-bold text-3xl text-primary sm:text-4xl md:text-5xl',
                  titleFont,
                )}
              >
                <span className="bg-primary px-3 py-2 text-background">
                  Cronograma
                </span>
              </h1>
              {editionLabel && (
                <p className="mt-4 text-primary text-xl sm:text-2xl md:text-3xl">
                  <span className="font-logo">
                    <span className="font-light">platanus hack</span>{' '}
                    <span className="font-medium">[26]</span>
                  </span>
                  <span className="font-title">{editionLabel}</span>
                </p>
              )}
              {dateLine && (
                <p className="mt-2 font-mono text-primary/70 text-sm md:text-base">
                  {dateLine}
                </p>
              )}
            </div>

            {event.startsAt && event.endsAt && (
              <Schedule
                timeSlots={timeSlots}
                startsAt={event.startsAt}
                endsAt={event.endsAt}
                timezoneOffset={timezoneOffset}
                timeZone={timeZone}
                titleFont={titleFont}
              />
            )}
          </div>
        </div>
      </div>
    </Ph26Shell>
  );
}
